import { AxiosInstanceBuilder } from '@digibricks/plugin-axios';
import { ASSIGNMENT_API, AssignmentApi, PRACTICE_ASSIGNMENT_API, PracticeAssignmentApi, EXAMINATION_ASSIGNMENT_API, ExaminationAssignmentApi, SECURITY_OPTION_API, SecurityOptionApi, ASSIGNMENT_CONFIGURATION_API, AssignmentConfigurationApi, SUBMISSION_API, SubmissionApi, PRACTICE_SUBMISSION_API, PracticeSubmissionApi, EXAMINATION_SUBMISSION_API, ExaminationSubmissionApi, ParticipatedAssignmentApi, PARTICIPATED_ASSIGNMENT_API } from './data-sources';
import { ASSIGNMENT_REPOSITORY_WEB_CONFIG } from './assignment-repository-web.config';
import { AssignmentMapper, AssignmentSummaryWebMapper, SecurityOptionMapper } from './repositories';
export var apiProviders = [{
  provide: AssignmentMapper,
  useValue: new AssignmentMapper()
}, {
  provide: AssignmentSummaryWebMapper,
  useValue: new AssignmentSummaryWebMapper()
}, {
  provide: SecurityOptionMapper,
  useValue: new SecurityOptionMapper()
}, {
  provide: AxiosInstanceBuilder,
  useFactory: function useFactory(config) {
    return new AxiosInstanceBuilder().withBaseUrl(config.baseUrl).withTimeout(config.timeout).withHeaders({
      Authorization: "Bearer ".concat(config.accessToken)
    });
  },
  inject: [ASSIGNMENT_REPOSITORY_WEB_CONFIG]
}, {
  provide: ASSIGNMENT_API,
  useFactory: function useFactory(axiosInstanceBuilder, assignmentSummaryWebMapper) {
    return new AssignmentApi(axiosInstanceBuilder.toInstance(), assignmentSummaryWebMapper);
  },
  inject: [AxiosInstanceBuilder, AssignmentSummaryWebMapper]
}, {
  provide: PRACTICE_ASSIGNMENT_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new PracticeAssignmentApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: EXAMINATION_ASSIGNMENT_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new ExaminationAssignmentApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: SECURITY_OPTION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new SecurityOptionApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: ASSIGNMENT_CONFIGURATION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new AssignmentConfigurationApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: SUBMISSION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new SubmissionApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: PRACTICE_SUBMISSION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new PracticeSubmissionApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: EXAMINATION_SUBMISSION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new ExaminationSubmissionApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: PARTICIPATED_ASSIGNMENT_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new ParticipatedAssignmentApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}];
export var responderAssignmentApiProviders = [].concat(apiProviders, [{
  provide: PRACTICE_SUBMISSION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new PracticeSubmissionApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: EXAMINATION_SUBMISSION_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new ExaminationSubmissionApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}, {
  provide: PARTICIPATED_ASSIGNMENT_API,
  useFactory: function useFactory(axiosInstanceBuilder) {
    return new ParticipatedAssignmentApi(axiosInstanceBuilder.toInstance());
  },
  inject: [AxiosInstanceBuilder]
}]);